//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "NIHSS",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
        f4: "",
        f5: "",
        f6: "",
        f7: "",
        f7_1: "",
        f8: "",
        f9: "",
        f10: "",
        f11: "",
        f12: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "清醒，反应灵敏" },
        { value: "1", name: "嗜睡，轻微刺激能唤醒，可回答问题，执行指令" },
        {
          value: "2",
          name: "昏睡或反应迟钝，需反复刺激，强烈或疼痛刺激才有非刻板的反应",
        },
        {
          value: "3",
          name: "昏迷，仅有反射性活动或自发性反应或完全无反应，软瘫，无反射",
        },
      ],
      dataList2: [
        { value: "0", name: "两项均正确" },
        { value: "1", name: "一项正确" },
        { value: "2", name: "两项均不正确" },
      ],
      dataList3: [
        { value: "0", name: "两项均正确" },
        { value: "1", name: "一项正确" },
        { value: "2", name: "两项均不正确" },
      ],
      dataList4: [
        { value: "0", name: "正常" },
        {
          value: "1",
          name: "部分凝视麻痹（单眼或双眼凝视异常，但无强迫凝视或完全凝视麻痹）",
        },
        { value: "2", name: "强迫凝视或完全凝视麻痹（不能被头眼反射克服）" },
      ],
      dataList5: [
        { value: "0", name: "无视野缺损" },
        { value: "1", name: "部分偏盲" },
        { value: "2", name: "完全偏盲" },
        { value: "3", name: "双侧偏盲（包括皮质盲）" },
      ],
      dataList6: [
        { value: "0", name: "正常" },
        { value: "1", name: "轻微（微笑时鼻唇沟变平，不对称）" },
        { value: "2", name: "部分（下面部完全或几乎完全瘫痪）" },
        { value: "3", name: "完全（单或双侧瘫痪，上下面部缺乏运动）" },
      ],
      dataList7: [
        {
          value: "0",
          name: "上肢无下落，置肢体于90°（或45°)坚持10秒",
        },
        {
          value: "1",
          name: "上肢能抬起但不能坚持10秒，下落时不撞击床或其他支持物",
        },
        {
          value: "2",
          name: "上肢试图抵抗重力，但不能维持坐位90°或仰位45°",
        },
        {
          value: "3",
          name: "上肢不能抵抗重力，肢体快速下落",
        },
        { value: "4", name: "上肢无运动" },
        {
          value: "8",
          name: "患者默认昏迷（DCS）—双侧上肢均无运动",
        },
        // {
        //   value: "9",
        //   name: "上肢截肢或关节融合（5a 左上肢；5b 右上肢）",
        // },
      ],
      dataList7_1: [
        {
          value: "0",
          name: "下肢无下落，于要求位置坚持5秒",
        },
        {
          value: "1",
          name: "下肢5秒末下落，不撞击床",
        },
        {
          value: "2",
          name: "下肢5秒内下落到床上，可部分抵抗重力",
        },
        {
          value: "3",
          name: "下肢立即下落到床上，不能抵抗重力",
        },
        { value: "4", name: "下肢无运动" },
        {
          value: "8",
          name: "患者默认昏迷（DCS）—双侧下肢均无运动",
        },
        // {
        //   value: "9",
        //   name: "下肢截肢或关节融合（6a左下肢； 6b右下肢）",
        // },
      ],
      dataList8: [
        { value: "0", name: "无共济失调" },
        { value: "1", name: "一个肢体有" },
        { value: "2", name: "两个肢体有，共济失调在：右上肢 1=有，2=无" },
        // {
        //   value: "9",
        //   name: "截肢或关节融合（左上肢1=有，2=无；右上肢1=有，2=无；左下肢1=有，2=无； 右下肢1=有，2=无）。",
        // },
      ],
      dataList9: [
        { value: "0", name: "正常" },
        {
          value: "1",
          name: "轻-中度感觉障碍（患者感觉针刺不尖锐或迟 钝，或针刺感缺失但有触觉）",
        },
        { value: "2", name: "重度-完全感觉缺失（面，上肢，下肢无触觉" },
      ],
      dataList10: [
        { value: "0", name: "正常" },
        { value: "1", name: "轻-中度失语：流利程度和理解能力部分下降， 但表达无明显受限" },
        { value: "2", name: "严重失语，交流是通过患者破碎的语言表达，听者须推理、询问、猜测，交流困难" },
        { value: "3", name: "不能说话或者完全失语，无言语或听力理解能力" },
      ],
      dataList11: [
        { value: "0", name: "正常" },
        { value: "1", name: "轻-中度，至少有些发音不清，虽有困难但能被理解" },
        { value: "2", name: "言语不清，不能被理解，但无失语或与失语不成比例，或失音" },
        // { value: "9", name: "气管插管或其他物理障碍" },
      ],
      dataList12: [
        { value: "0", name: "正常" },
        { value: "1", name: "视、触、听、空间觉或个人的忽视；或对一种 感觉的双侧同时刺激忽视" },
        { value: "2", name: "严重的偏侧忽视或一种以上的偏侧忽视；不认识自己的手；只能对一侧空间定位" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/NIHSS.vue